import axios from 'axios';
import { useMutation, UseMutationOptions } from './useMutation';
import { useApp } from '../designs/paper/context/AppContext';
import {
  CartSessionResponse,
  UpdateReservationDraftParams,
} from '../../../../../shared/types/cartSession';

interface UseUpdateReservationDraftParams extends Omit<
  UpdateReservationDraftParams,
  'reservationDraftId'
> {
  propertyId: string;
  cartSessionId: string;
  reservationDraftId: string;
}

type UseUpdateReservationDraftOptions = UseMutationOptions<
  CartSessionResponse,
  Error,
  UseUpdateReservationDraftParams
>;

/**
 * Hook to update reservation draft (add/update customer, tickets, packages, addons)
 * @param options - Mutation options
 */
export function useUpdateReservation(options?: UseUpdateReservationDraftOptions) {
  const { config } = useApp();

  return useMutation<CartSessionResponse, Error, UseUpdateReservationDraftParams>(
    async ({ cartSessionId, reservationDraftId, ...data }) => {
      const response = await axios.put<CartSessionResponse>(
        config.updateReservationUrl
          .replace(':cartId', cartSessionId)
          .replace(':draftId', reservationDraftId),
        data
      );
      return response.data;
    },
    options
  );
}
